// extracted by mini-css-extract-plugin
export var brandHeader = "_redotech-redo-customer-portal-returns-app-lib-returns-components-dropoffs-happy-returns-confirmation-card-brand-header";